import { TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Nullable } from "../../../../../common/types/nullable";
import { StyledTableCell } from "../styles";
import { SelectedAccumulation } from "../types";

type Props = {
  headerColumns: {
    keys: string[];
    stateNames: string[];
  };
  dataIncludesDelta: boolean;
  selectedAccumulation: Nullable<SelectedAccumulation>;
};

const AccumulationsTableHeaderTableCells = ({
  headerColumns,
  dataIncludesDelta,
  selectedAccumulation,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell width="20%">
          {t("accumulationKeys.modificationDate")}
        </StyledTableCell>
        {headerColumns.keys.map((key) => (
          <StyledTableCell
            align={key === "custOrgId" ? "left" : "center"}
            key={key}
            sx={{ padding: "8px" }}
          >
            {t(`accumulationKeys.${key}`)}
          </StyledTableCell>
        ))}
        {headerColumns.stateNames.map((value) => (
          <StyledTableCell
            align="right"
            key={value}
            sx={{
              padding: "8px",
              "&::first-letter": {
                textTransform: "capitalize",
              },
            }}
          >
            {value}
          </StyledTableCell>
        ))}
        {(dataIncludesDelta || selectedAccumulation?.isInternal) && (
          <StyledTableCell width="8%" />
        )}
      </TableRow>
    </TableHead>
  );
};

export default AccumulationsTableHeaderTableCells;
